import _extends from "@babel/runtime/helpers/esm/extends";
// this file has been generated using SVGR.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 8c-3.861 0-7 3.136-7 7 0 3.861 3.136 7 7 7a7.007 7.007 0 006.929-6H43c1.333 0 1.333-2 0-2h-5.071A7.006 7.006 0 0031 8zm5 7.021v-.042A5.004 5.004 0 0031 10c-2.757 0-5 2.241-5 5 0 2.757 2.241 5 5 5 2.75 0 4.989-2.23 5-4.979zM5 16h16c1.333 0 1.333-2 0-2H5c-1.334 0-1.334 2 0 2zm22 16h16c1.334 0 1.334 2 0 2H27c-1.333 0-1.333-2 0-2zm-10 8c3.864 0 7-3.139 7-7 0-3.864-3.139-7-7-7a7.007 7.007 0 00-6.93 6H5c-1.334 0-1.334 2 0 2h5.07A7.01 7.01 0 0017 40zm0-12c2.757 0 5 2.241 5 5 0 2.757-2.241 5-5 5-2.757 0-5-2.241-5-5 0-2.757 2.241-5 5-5z",
    fill: "currentColor"
  }));
};

var SvgPreferences = styled(SvgComponent).withConfig({
  displayName: "Preferences__SvgPreferences",
  componentId: "sc-1v4r54o-0"
})(["", " ", ""], size, color);
export default SvgPreferences;